module.exports = __webpack_public_path__ + "cf6697b803818c9ee716b25d48f88f82.svg";